import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';

//import { formatDate, parseDate } from 'react-day-picker/moment';

export default class DatePickerRange extends React.Component {
    constructor(props) {
        super(props);
        this.handleFromChange = this.handleFromChange.bind(this);
        this.handleToChange = this.handleToChange.bind(this);
        this.state = {
            from: undefined,
            to: undefined,
        };
    }
    showFromMonth() {
        const { from, to } = this.state;
        if (!from) {
            return;
        }
       
    }
    handleFromChange(from) {
        // Change the from date and focus the "to" input field
        this.setState({ from });
    }
    handleToChange(to) {
        this.setState({ to }, this.showFromMonth);
    }
    render() {
        const { from, to } = this.state;
        const modifiers = { start: from, end: to };
        return (
            <div>
                <DayPickerInput
                    value={from}
                    placeholder="From"
                    format="LL"
                    //formatDate={formatDate}
                    //parseDate={parseDate}
                    dayPickerProps={{
                        selectedDays: [from, { from, to }],
                        disabledDays: { after: to },
                        toMonth: to,
                        modifiers,
                        numberOfMonths: 2,
                        onDayClick: () => this.to.getInput().focus(),
                        labels: { nextMonth: "Next Month", previousMonth: "Previous Month" }
                    }}
                    onDayChange={this.handleFromChange}
                />{' '}
                —{' '}
                <span>
                    <DayPickerInput
                        ref={el => (this.to = el)}
                        value={to}
                        placeholder="To"
                        format="LL"
                        //formatDate={formatDate}
                        //parseDate={parseDate}
                        dayPickerProps={{
                            selectedDays: [from, { from, to }],
                            disabledDays: { before: from },
                            modifiers,
                            month: from,
                            fromMonth: from,
                            numberOfMonths: 2,
                        }}
                        onDayChange={this.handleToChange}
                    />
                </span>
                

            </div>
        );
    }
}
